module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento3.f325aa03.svg";